export const GoogleMapApiConfig = 'AIzaSyDZEcAyglZAVsyWmQVQNY5hgw3QTAzvw4c';